// #2357 -- score-api redacts a sheet for a caller who is neither an admin nor
// seated at that sheet's judge (and the ride is not FINAL): the marks/totals
// are stripped and `scoresHidden: true` is set (scoresheet.js
// redactScoresForUnassignedViewer), but `id` and `version` are kept. Such a
// row must never land in the local scoreSheets cache: db.js's
// bulkPutAncestorAware would overwrite a cached full sheet with it and re-seat
// an open useScoreSheet on it, #906's never-downgrade guard would then keep it
// over the real sheet, and the next save (same version, so baseVersion
// matches) would overwrite the real movementScores with the blank form.
export const isScoresHiddenSheet = (sheet) => sheet?.scoresHidden === true;

// Every server row a caller may cache: drops the redacted ones.
export const cacheableServerSheets = (sheets) =>
  (sheets ?? []).filter((s) => !isScoresHiddenSheet(s));
